import Vue from 'vue'
import Vuex from 'vuex'
import firebase from '@/firebase'
import Cookies from 'js-cookie'

Vue.use(Vuex)

const state = {
  user: {},
  users: {},
  transports: {
    month: null,
    sort: [],
    contents: {}
  },

  transportListScrollX: 0,
  wait: false
}

const isProduction = process.env.NODE_ENV == "production"

const mutations = {
  SET_EMAIL(state, email) {
    Cookies.set('email', email, {
      secure: isProduction,
      sameSite: "lax",
      expires: 10
    })
  },
  SET_TOKEN(state, token) {
    Cookies.set('token', token, {
      secure: isProduction,
      sameSite: "lax"
    })
  },
  INIT_USER(state) {
    state.user = {}
  },
  SET_USER(state, user) {
    state.user = Object.assign(state.user, user)
  },
  SET_COMPANY(state, company) {
    state.user.company_name = company.company_name
    state.user.company_code = company.company_code
  },
  SET_USERS(state, users) {
    state.users = users
  },
  SET_TRANSPORTS(state, transports) {
    state.transports.month = transports.month
    state.transports.sort = transports.sort
    state.transports.contents = transports.contents
  },
  SET_TRANSPORTS_SCROLL_X(state, scroll) {
    state.transportScrollX = scroll
  },
  SET_WAIT(state, wait) {
    state.wait = wait
  }
}

const actions = {
  setEmail(context, email) {
    return context.commit("SET_EMAIL", email)
  },
  setToken(context, token) {
    return context.commit("SET_TOKEN", token)
  },
  setUser(context, user) {
    return context.commit("SET_USER", user)
  },
  setCompany(context, company) {
    return context.commit("SET_COMPANY", company)
  },
  setUsers(context, users) {
    return context.commit("SET_USERS", users)
  },
  setTrasnports(context, transports) {
    return context.commit("SET_TRANSPORTS", transports)
  },
  setTransportListScrollX(context, scroll) {
    return context.commit("SET_TRANSPORTS_SCROLL_X", scroll)
  },
  wait(context, wait) {
    return context.commit("SET_WAIT", wait)
  },
  logout(context) {
    firebase.auth().signOut().then(() => {
      return context.commit("INIT_USER")
    })
  }
}

export default {
  state,
  mutations,
  actions
}
